import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useHistory } from 'react-router-dom';
import { ValidatorForm } from 'react-form-validator-core';
import TextValidator from '../components/TextValidator';
import SelectValidator from '../components/SelectValidator';
import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import Swal from 'sweetalert2'
import { DESERVE_STATUS, DESERVE_STATUS_STRING_VALUE } from "../components/constants";

const AddEditDeserve = () => {
    const history = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isRunning, setIsRunning] = useState(false);

    // attributes of deserve
    const { idProduct, idUser } = useParams();
    const [status, setStatus] = useState("");
    const [productId, setProductId] = useState("");
    const [productName, setProductName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [remarkByAdmin, setRemarkByAdmin] = useState("");
    const [remarkByCompany, setRemarkByCompany] = useState("");
    const [userId, setUserId] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [createdts, setCreatedts] = useState("");
    const [updatedts, setUpdatedts] = useState("");
    const [expirationDate, setExpirationDate] = useState("");
    const [deservedon, setDeservedon] = useState("");
    const [actualStatus, setActualStatus] = useState("");
    const [postUrl, setPostUrl] = useState("");
    const [price, setPrice] = useState("");
    const [appType, setAppType] = useState("");


    useEffect(() => {
        async function getDeserve() {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/admin/deserves/${idProduct}/${idUser}`,
                { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
            const deserve = await response.json();
            setDeserve(deserve);
            setIsLoaded(true);
            setIsRunning(false);
        }

        if (idProduct && idUser) {
            getDeserve();
        }
        else {
            setIsLoaded(true);
            setIsRunning(false);
        }


    }, []);

    function setDeserve(deserves) {
        let deserve = deserves[0];//Handle null condition

        setStatus(deserves.status);
        setProductId(deserves.idProduct);
        setProductName(deserves.name);
        setCompanyName(deserves.companyName);
        setRemarkByAdmin(deserves.remarkByAdmin);
        setRemarkByCompany(deserves.remarkByCompany);
        setUserId(deserves.userId);
        setUserEmail(deserves.userEmail);
        setCreatedts(new Date(deserves.createdts).toISOString().split("T")[0]);
        setUpdatedts(new Date(deserves.updatedts).toISOString().split("T")[0]);
        setExpirationDate(new Date(deserves.expirationDate).toISOString().split("T")[0]);
        setDeservedon(deserves.deservedon);
        setActualStatus(deserves.actualStatus);
        setPostUrl(decodeURIComponent(deserves.postUrl));
        setPrice(decodeURIComponent(deserves.price));
        setAppType(deserves.appType);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const result = await swalWithBootstrapButtons.fire({
            title: "Bist Du sicher, dass Du speichern möchtest?",
            text: "",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Ja, speichern!",
            cancelButtonText: "Nein, abbrechen!",
            //reverseButtons: true
        });
        if (result.isConfirmed) {
            save(event)
        }
    }

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        // Implement your logic for handling input change
        switch (name) {
            case "status":
                setStatus(value);
                break;
            case "remarkByAdmin":
                setRemarkByAdmin(value);
                break;
            default:
                break;
        }
    }


    const backToAllDeserves = () => {
        try {
            history.push("/admin");
        } catch (error) {
            swalWithBootstrapButtons.fire({
                title: "Oops...",
                text: error.message,
                icon: "error"
            });
        }
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-outline-warning",
            cancelButton: "btn btn-outline-warning"
        },
        buttonsStyling: false
    });


    const save = async (event) => {
        try {
            // Show loading Swal
            Swal.fire({
                title: 'Bitte warten...',
                html: 'Speichere...',  // Can show some message
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const accessToken = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", accessToken);

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", `Bearer ${accessToken}`);

            //Add character validations on each property
            const deserveDetails = JSON.stringify({
                "idProduct": productId,
                "userId": userId,
                "status": status,
                "postUrl": postUrl,
                "createdts": createdts,
                "updatedts": updatedts,
                "expirationDate": expirationDate,
                "deservedon": deservedon,
                "actualStatus": actualStatus,
                "appType": appType,
                "remarkByAdmin": remarkByAdmin,
            });

            const requestOptions = {
                headers: myHeaders,
                body: deserveDetails,
                redirect: "follow"
            };
            let url;
            //edit
            requestOptions.method = "PUT";
            url = `${serverUrl}/api/admin/deserves/${idProduct}/${idUser}`;

            let response = await fetch(url, requestOptions);
            let result = await response.json();
            // Close loading Swal
            Swal.close();

            if (result.isSuccessful) {
                swalWithBootstrapButtons.fire({
                    title: "Gespeichert!",
                    text: "",
                    icon: "success"
                });
                backToAllDeserves();//Go back all products page.
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.message,
                    //footer: '<a href="#">Why do I have this issue?</a>'
                }).then(() => {
                    window.location.reload(); // Reloads when user clicks "OK"
                });
            }
        } catch (err) {
            // Close loading Swal
            Swal.close();

            // catches errors both in fetch and response.json
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err,
                //footer: '<a href="#">Why do I have this issue?</a>'
            }).then(() => {
                window.location.reload(); // Reloads when user clicks "OK"
            });
        }
    }

    return (
        <React.Fragment>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{idProduct && idUser == "Deserve bearbeiten"}</h1>
                        </div>
                        {/* <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="#">{"Startseite"}</a></li>
                                <li className="breadcrumb-item active">{idProduct?.toString().trim() == "Titel" ? "Produkt hinzufügen" : "Produkt bearbeiten"}</li>
                            </ol>
                        </div> */}
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="card card-solid">
                    <Spinner isRunning={isRunning} />

                    {!isLoaded ? <div className="text-center"><Loader /></div> :
                        <div className="container-fluid">
                            <ValidatorForm onSubmit={handleSubmit}>
                                <div className="box-body">
                                    <div className="alert alert-success" id="successMessage" style={{ display: 'none' }}></div>
                                    <div className="alert alert-danger" id="errorMessage" style={{ display: 'none' }}></div>
                                    <div className="form-group">

                                        <div className="row" >
                                            <div className="col-md-12">
                                                <SelectValidator
                                                    onChange={handleInputChange}
                                                    name="status"
                                                    isRequired={true}
                                                    label={"Status"}
                                                    value={status ? status : ""}
                                                >
                                                    <option disabled hidden value=""> </option>
                                                    {Object.entries(DESERVE_STATUS)
                                                        .filter(([key, value]) => value !== 0) // skip 0
                                                        .map(([key, value]) => (
                                                            <option key={value} value={value}>
                                                                {DESERVE_STATUS_STRING_VALUE[key]}
                                                            </option>
                                                        ))}
                                                </SelectValidator>
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="remarkByAdmin"
                                                    value={remarkByAdmin ? remarkByAdmin : ""}
                                                    isRequired={true}
                                                    label={"Remark By Admin"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12" >
                                                <TextValidator
                                                    name="remarkByCompany"
                                                    value={remarkByCompany ? remarkByCompany : ""}
                                                    label={"Remark By Company"}
                                                    disabled={true} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="companyName"
                                                    value={companyName ? companyName : ""}
                                                    isRequired={true}
                                                    label={"Name des Unternehmens"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="productId"
                                                    value={productId ? productId : ""}
                                                    isRequired={true}
                                                    label={"Produkt ID"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="productName"
                                                    value={productName ? productName : ""}
                                                    isRequired={true}
                                                    label={"Produkt Name"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="userId"
                                                    value={userId ? userId : ""}
                                                    isRequired={true}
                                                    label={"User ID"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="userEmail"
                                                    value={userEmail ? userEmail : ""}
                                                    isRequired={true}
                                                    label={"User Email"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="createdts"
                                                    value={createdts ? createdts : ""}
                                                    isRequired={true}
                                                    label={"Erstellt am"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="updatedts"
                                                    value={updatedts ? updatedts : ""}
                                                    isRequired={true}
                                                    label={"Bearbeitet am"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="expirationDate"
                                                    value={expirationDate ? expirationDate : ""}
                                                    isRequired={true}
                                                    label={"deserve Zeit bis"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="price"
                                                    value={price ? price : ""}
                                                    isRequired={true}
                                                    label={"Benötigte Likes"} />
                                            </div>
                                        </div>
                                        {/* <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="actualStatus"
                                                    value={actualStatus ? actualStatus : ""}
                                                    isRequired={true}
                                                    label={"Aktueller Eintrag"} />
                                            </div>
                                        </div> */}
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    disabled={true}  // Dropdown deaktiviert
                                                    onChange={handleInputChange}
                                                    name="postUrl"
                                                    value={postUrl ? postUrl : ""}
                                                    isRequired={true}
                                                    label={"Post URL"} />
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    disabled={true}  // Dropdown deaktiviert
                                                    name="appType"
                                                    value={appType ? appType : ""}
                                                    isRequired={true}
                                                    label={"Wo geteilt? 1 = Facebook, 2 = Instagram, 3 = X, 4 = TikTok, 5 = LinkedIn"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="form-group">
                                        <div className="col-md-12">
                                            <div>
                                                <input type="submit" value={"Speichern"} className="btn btn-outline-warning col-md-6" />
                                                <input type="button" value={"Abbrechen"} className="btn btn-outline-warning col-md-6" onClick={backToAllDeserves} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ValidatorForm>

                        </div>

                    }
                </div>
            </section>
        </React.Fragment>
    );
};
export default AddEditDeserve;

